import { Component, Input, OnInit } from '@angular/core'
import { Notification } from '../../models/notification'
import { environment } from 'src/environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../services/notifications.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss']
})
export class NotificationCardComponent implements OnInit {
  @Input() notification: Notification | undefined
  @Input() isDropDown = false
  imgPath = environment.attachmentPath
  subscriptions = new Subscription()
  today = new Date().toISOString().split('T')[0]
  constructor(public translate: TranslateService, private notificationsServece: NotificationService,
    private router: Router) { }

  ngOnInit(): void {
  }

  markAsRead(notification: any) {
    notification?.isReaded?.toString() == 'false' ?
      this.subscriptions.add(
        this.notificationsServece.markAsRead([notification?.id]).subscribe(res => {
          this.router.navigate(['/layout/' + notification?.routePath])
        })
      ) : this.router.navigate(['/layout/' + notification?.routePath])
  }

  checkIfToday(date:any){
    return date?.split('T')[0] == this.today
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
